/**
 * AlertDialog — non-dismissible confirmation primitive (ADR-114).
 *
 * Re-exports the shared primitive (centered on all viewports, never closes
 * on backdrop/ESC) and keeps the admin-console button styling for
 * Action/Cancel via `buttonVariants`.
 */

import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction as SharedAlertDialogAction,
  AlertDialogCancel as SharedAlertDialogCancel,
} from '@vanguard-atlas/shared';
import type {
  AlertDialogActionProps,
  AlertDialogCancelProps,
} from '@vanguard-atlas/shared';

export {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
};

export function AlertDialogAction({ className, ...props }: AlertDialogActionProps) {
  return <SharedAlertDialogAction className={cn(buttonVariants(), className)} {...props} />;
}

export function AlertDialogCancel({ className, ...props }: AlertDialogCancelProps) {
  return (
    <SharedAlertDialogCancel
      className={cn(buttonVariants({ variant: 'outline' }), 'mt-2 sm:mt-0', className)}
      {...props}
    />
  );
}
